import { defineComponent as _defineComponent } from 'vue'
import mapboxgl from 'mapbox-gl'
import GeoJsonSource from '@/components/field-view-next/mapbox/GeoJsonSource.vue'
import LayerGroup from '@/components/field-view-next/mapbox/LayerGroup.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SinglePointPin',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: object
}



const layers: mapboxgl.AnyLayer[] = [
  {
    id: 'single-point-pin',
    type: 'symbol',
    layout: {
      'icon-allow-overlap': true,
      'icon-size': 1,
      'icon-image': 'owned__#0650b2__mdi-map-marker',
      'icon-anchor': 'bottom',
    },
  },
]

return { __sfc: true,props, layers, GeoJsonSource, LayerGroup }
}

})